import { useState, useEffect } from 'react'
import _debounce from 'lodash.debounce'
import { useDispatch } from 'react-redux'
import { actions } from '../store/reducers/assignment.reducer'
import { useParams } from 'react-router'

const useProjectionCostEstimation = (arrayOfCriteria, shouldCallHook = true, llmVersion) => {
    const { token } = useParams()
    const [projectionCostDetails, setProjectionCostDetails] = useState('...')
    const dispatch = useDispatch()

    useEffect(() => {
        const debouncedFunction = _debounce(async () => {
            if (shouldCallHook && arrayOfCriteria) {
                setProjectionCostDetails('...')
                const cost = await dispatch(
                    actions.estimateProjectionCost(
                        token,
                        arrayOfCriteria,
                        message => setProjectionCostDetails(`(${message})`),
                        llmVersion,
                    ),
                )
                if (cost !== undefined) {
                    if (cost < 1) {
                        setProjectionCostDetails('')
                    } else if (cost) {
                        setProjectionCostDetails(`$${cost}`)
                    }
                }
            }
        }, 1000)

        debouncedFunction()

        return () => {
            debouncedFunction.cancel()
        }
    }, [token, arrayOfCriteria, shouldCallHook, dispatch])

    return projectionCostDetails
}

export default useProjectionCostEstimation
